import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";
import { AppShell, CardPanel, FormField, PrimaryButton } from "../components";

const EyeOpenIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M1.5 12s3.8-6.5 10.5-6.5S22.5 12 22.5 12s-3.8 6.5-10.5 6.5S1.5 12 1.5 12Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M3 3l18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.9 5.9A11 11 0 0 1 12 5.5c6.7 0 10.5 6.5 10.5 6.5a19.2 19.2 0 0 1-4.2 4.8M6.2 8.2A19 19 0 0 0 1.5 12s3.8 6.5 10.5 6.5a11 11 0 0 0 4.1-.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const response = await fetch(apiUrl("/api/auth/login"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        if (rememberMe) {
          localStorage.setItem("authToken", data.token);
        } else {
          sessionStorage.setItem("authToken", data.token);
        }

        navigate("/HomePage");
      } else {
        setError(data.error || data.message || "Login failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error(err);
    }
  };

  return (
    <AppShell
      sidebarImage="/sidebar_avatar.png"
      logoPosition="bottom"
      contentClassName="ui-shell__content--centered"
    >
      <CardPanel className="ui-card-panel--center ui-login-panel">
        <div className="ui-auth-card">
          <div className="ui-auth-card__head">
            <h1>Welcome</h1>
            <p>Login to your Dashboard</p>
          </div>

          <form className="ui-auth-card__form" onSubmit={handleLogin}>
            <FormField
              label="Email Address"
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="johndoe@example.com"
              required
              autoComplete="email"
            />

            <FormField
              label="Password"
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="************"
              required
              autoComplete="current-password"
              rightElement={
                <button
                  type="button"
                  className="ui-form-toggle ui-form-toggle--icon"
                  onClick={() => setShowPassword((current) => !current)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeOpenIcon />}
                </button>
              }
            />

            <div className="ui-inline-row">
              <label className="ui-helper-text">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe((current) => !current)}
                  style={{ marginRight: "8px" }}
                />
                Remember Me
              </label>
              {/* <span className="ui-helper-text">Forgot Password?</span> */}
            </div>

            {error ? <p className="ui-error-text">{error}</p> : null}

            <PrimaryButton className="ui-auth-submit" type="submit" size="lg">
              LOGIN
            </PrimaryButton>
          </form>
        </div>
      </CardPanel>
    </AppShell>
  );
};

export default LoginPage;
